import { format, parse } from 'date-fns';

export const excludeAt =
  (isExclude: boolean = false) =>
  (str: string) =>
    isExclude ? str.replace(/!/g, '') : str;

export const withoutWhitespace = (str: string) => str.replace(/\s/g, '');

export const isValidIFSC = (v: string) => v.replace(/^[A-Z]{4}0[\d\w]{6}$/g, '');

export const parseAadhaarNumber = (aadhaarNumber: string) => {
  return `${aadhaarNumber.slice(0, 4)} ${aadhaarNumber.slice(4, 8)} ${aadhaarNumber.slice(8)}`;
};

export const parseZoopDate = (zoopDate: string = '1/7/2019') => {
  let d: number, m: number, y: number;

  if (zoopDate.includes('/')) {
    // Date format: DD/MM/YYYY
    const [day, month, year] = zoopDate.split('/');
    d = +day;
    m = +month - 1;
    y = +year;
  } else if (zoopDate.includes('-')) {
    // Date format: YYYY-MM-DD
    const [year, month, day] = zoopDate.split('-');
    d = +day;
    m = +month - 1;
    y = +year;
  } else {
    throw new Error('Unsupported date format');
  }

  return new Date(y, m, d);
};

export const parseDate = (v: string) => parse(v, 'dd.MM.yyyy', new Date());

export const parseDateForDb = (date: Date) => format(new Date(date), 'yyyy-MM-dd');

export const getFormattedBankAccountNumber = (bankAccountNumber: string) => {
  const ban = bankAccountNumber;

  return `${ban.slice(0, 4)} ${ban.slice(4, 8)} ${ban.slice(8, 13)}`;
};

export const replaceBrTagsWithNewline = (inputString: string) => {
  return inputString.replace(new RegExp(/<\s*\/?br\s*\/?>/gi), '\n');
};

export const removeATags = (inputString: string): string => {
  return inputString.replace(new RegExp(/<a\s+[^>]*>(.*?)<\/a>/gi), '$1');
};
